// RULES:
// 1. Base URLS do NOT have trailing '/'
// 1.1 Means paths should have leading '/'

export const configSettings = {
    siteName: 'Unora App',

    // API Configuration
    apiUrl: import.meta.env.VITE_API_PYTHON_BASE_URL,
    authApiUrl: import.meta.env.VITE_API_AUTH_BASE_URL, // TODO: make auth api
    informalApiUrl: import.meta.env.VITE_ANALYTICS_API,

    // Environment
    environment: import.meta.env.VITE_ENVIRONMENT,
    isDevelopment: import.meta.env.VITE_ENVIRONMENT !== 'production',
    isProduction: import.meta.env.VITE_ENVIRONMENT === 'production',

    // UI Configuration
    defaultTheme: 'dark' as 'dark' | 'light' | 'system',

    // Domain settings
    noHttpsAdminDomain: import.meta.env.VITE_DOMAIN_NO_PROTOCOL,
    adminDomain: import.meta.env.VITE_DOMAIN_NO_PROTOCOL
        ? `https://${import.meta.env.VITE_DOMAIN_NO_PROTOCOL}`
        : undefined,

    frontDomain: import.meta.env.VITE_FRONT_DOMAIN_NO_PROTOCOL
        ? `https://${import.meta.env.VITE_FRONT_DOMAIN_NO_PROTOCOL}`
        : undefined,

    // Analytics and tracking
    analyticsApi: import.meta.env.VITE_ANALYTICS_API,

    // Sentry
    sentryDsn: import.meta.env.VITE_SENTRY_DSN,
};
// Type-safe config access
export type ConfigSettings = typeof configSettings;
